<style scoped>
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .lists{
    display: block!important;
  }
}
.center-ele{
  margin-left: 50px;
  text-align: center;
  font-weight: bold;
}
.desc-ch{
  margin-top:-15px;
}
.desc-eh{
  margin-top:0px;
}
.text-desc-list{
  padding-left: 26px;
}
.list-item{
  position: relative;
  padding-left: 20px !important;
}
.circle{
  display: inline-block;
  background: #014492;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 20px;
  position: absolute;
  left: 0px;
  top:4px;
}
.text-row{
  padding:10px 0;
}
</style>
<template>
  <div class="wrap wrap-intel">
    <div class="banner">
      <img src="@/assets/images/banner_12.png" class="img-fluid">
      <div class="banner-info">
        <div class="left">
          <h2>单链核酸合成仪-768B</h2>
          <p style="line-height: 2;font-size: 16px">单链核酸合成仪-768B是一种经济，通用的高通量平台，循环时间短，试剂
            消耗低。它可以灵活地以2 nmol至50 nmol的合成规模合成不同长
            度的序列。</p>

            <p class="mt10" style="line-height: 2;font-size: 16px">单链核酸合成仪-768B生产的DNA/RNA寡核苷酸可用于基因合成、PCR/RT-
            PCR、siRNA/RNAi、DNA/RNA测序、免疫和生物化学、高通量筛
            选、天然产物生物合成、基因构建、反转录PCR、杂交、单核苷酸
            多态性检测、基因诊断和治疗研究。</p>
        </div>
        <div class="img_a">
          <img src="@/assets/images/compose768_11.png" width="100%" class="product">
          <div class="center-ele desc-ch">单链核酸合成仪-768B</div>
          <div class="center-ele desc-eh">型号：Syn-HCY-768B</div>
        </div>
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container container1">
      <div class="c-title">产品特点</div>
      <el-row type="flex" align="middle">
        <el-col :span="10">
          <div class="tc"><img src="@/assets/images/compose768_11.png" width="100%"></div>
        </el-col>
        <el-col :span="14" class="text-desc-list">
          <el-row class="text-row">
            <el-col :span="12" class="list-item"><div><span class="circle"></span>中文操作系统，操作简单</div></el-col>
            <el-col :span="12" class="list-item"><div><span class="circle"></span>独特吹压模块，保证合成质量</div></el-col>
          </el-row>
          <el-row class="text-row">
            <el-col :span="12" class="list-item"><div><span class="circle"></span>可合成DNA/RNA</div></el-col>
            <el-col :span="12" class="list-item"><div><span class="circle"></span>并行分配技术，快速合成</div></el-col>
          </el-row>
          <!-- <ul class="lists">
            <li>中文操作系统，操作简单；</li>
            <li>独特吹压模块，保证合成质量；</li>
            <li>可合成DNA/RNA；</li>
            <li>并行分配技术，快速合成。</li>
          </ul> -->
        </el-col>
      </el-row>
      <div class="c-title">性能参数</div>
      <el-row :gutter="40">
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">电源</td>
              <td>220 V</td>
            </tr>
            <tr>
              <td>功率</td>
              <td>1000 W</td>
            </tr>
            <tr>
              <td>重量</td>
              <td>90 kg</td>
            </tr>
            <tr>
              <td>合成规模</td>
              <td>2 nmol-50 nmol</td>
            </tr>
            <tr>
              <td>试剂瓶口</td>
              <td>6个</td>
            </tr>
            <tr>
              <td>碱基瓶口</td>
              <td>4个</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">工作温度</td>
              <td>25 <span style="font-size:16px">±</span> 3 ℃</td>
            </tr>
            <tr>
              <td>相对湿度</td>
              <td>≤ 30%RH</td>
            </tr>
            <tr>
              <td>外形尺寸</td>
              <td>1200 x 700 x 680 mm</td>
            </tr>
            <tr>
              <td>合成通道</td>
              <td>768</td>
            </tr>
            <tr>
              <td>单次循环时间</td>
              <td>9-10 min</td>
            </tr>
            <tr>
              <td>耦合效率</td>
              <td>≥ 99%</td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <div class="dispose">
        <div class="title">标准配置</div>
        <!-- <ul class="lists">
          <li>8个瓶位</li>
          <li>加载的标准协议</li>
          <li>用于远程监控的全功能API</li>
          <li>戴尔主机和显示器</li>
          <li>从2 nmol到50 nmol的合成范围</li>
          <li>维修工具</li>
          <li>在Windows7及Windows10运行的灵活易用的软件</li>
          <li>运行日志</li>
          <li>混合骨架能力（硫代磷酸酯和磷酸二脂）</li>
        </ul> -->
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>4个碱基瓶位</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>加载的标准协议</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>用于远程监控的全功能API</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>戴尔主机和显示器</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>从2 nmol到50 nmol的合成范围</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>维修工具</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>在Windows7及Windows10运行的灵活易用的软件</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>运行日志</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>混合骨架能力（硫代磷酸酯和磷酸二脂）</div></el-col>
          <el-col :span="12" class="list-item"></el-col>
        </el-row>
      </div>
      <div class="dispose">
        <div class="title">可选配置</div>
        <!-- <ul class="lists">
          <li>UPS电源备份</li>
          <li>多试剂瓶盖适配器</li>
          <li>氩气压力传感器</li>
          <li>软件与内部LIMS的定制集成</li>
        </ul> -->
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>UPS电源备份</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>多试剂瓶盖适配器</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>氩气压力传感器</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>软件与内部LIMS的定制集成</div></el-col>
        </el-row>
      </div>
      <div class="dispose">
        <div class="title">性能指标</div>
        <!-- <ul class="lists">
          <li>合成规模：2 nmol到50 nmol</li>
          <li>合成条数：1到768条序列</li>
          <li>自动断电保护</li>
          <li>合成序列：普通序列、修饰引物、探针、简并碱基和特殊碱基</li>
          <li>合成时间：标准合成程序768条，9-10 min/bp</li>
          <li>功能强大：DNA、RNA、LNA、UNA、硫代和修饰都可以高质量低成本合成</li>
        </ul> -->
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>合成规模：2 nmol到50 nmol</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>合成条数：1到768条序列</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>自动断电保护</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>合成序列：普通序列、修饰引物、探针、简并碱基和特殊碱基</div></el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="12" class="list-item"><div><span class="circle"></span>合成时间：标准合成程序768条，9-10 min/bp</div></el-col>
          <el-col :span="12" class="list-item"><div><span class="circle"></span>功能强大：DNA、RNA、LNA、UNA、硫代和修饰都可以高质量低成本合成</div></el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>
<style scoped>
@import url("../../assets/akta.css");
</style>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/compose768.vue